import {
    Button,
    Col,
    Row,
    Badge,
    OverlayTrigger,
    Tooltip,
} from "react-bootstrap";
import { DatePicker } from "antd";
import moment from "moment";
import { Filter } from "react-feather";
import { useEffect, useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import api from "../../../../../service/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import { faFileExcel } from "@fortawesome/free-regular-svg-icons";
import Select from "react-select";
import { addDefaultOption } from "../../../../../utils/utility";

export const Search = ({
    setSearchValue,
    searchValue,
    search,
    generateReport,
    companyName,
    setCompanyName,
    excelExport,
}) => {
    const [hasMore, setHasMore] = useState(true);
    const [salesPersons, setSalesPersons] = useState();
    const handleLoadMore = async (search, { page }) => {
        if (!search) {
            return {
                options: [],
                hasMore: false,
            };
        }
        const response = await api.get("tms/companies-options", {
            search: search,
            page: page,
        });
        const { options: newOptions, hasMore: newHasMore } = response;
        setHasMore(newHasMore);
        return {
            options: newOptions,
            hasMore: newHasMore,
            additional: {
                page: page + 1,
            },
        };
    };

    const updateDateFilter = (key, value) => {
        const formattedDate = value ? moment(value).format("YYYY-MM-DD") : null;
        setSearchValue((prev) => ({
            ...prev,
            [key]: formattedDate,
            ...(key === "documentFrom" && { document_from: formattedDate }),
            ...(key === "documentTo" && { document_to: formattedDate }),
            ...(key === "paymentTo" && { payment_to: formattedDate }),
        }));
    };

    const getSalesPerson = async () => {
        try {
            const companyResponse = await api.get(`tms/get-sales-persons?has_remaining_amount=1`);
            setSalesPersons(companyResponse);
        } catch (error) {}
    };

    useEffect(() => {
        getSalesPerson();
    }, []);

    return (
        <div className="mb-3">
            <Row className="g-2 align-items-end">
                <Col md={5}>
                    <div className="mb-1 text-muted fw-semibold">
                        Document Date
                    </div>
                    <Row className="g-2 align-items-center">
                        <Col md={5}>
                            <DatePicker
                                id="document-from-date-picker"
                                value={
                                    searchValue.documentFrom
                                        ? moment(
                                              searchValue.documentFrom,
                                              "YYYY-MM-DD"
                                          )
                                        : null
                                }
                                name="documentFrom"
                                className="form-control"
                                placeholder="From"
                                onChange={(e) =>
                                    updateDateFilter("documentFrom", e)
                                }
                            />
                        </Col>

                        <Col
                            md="auto"
                            className="d-flex align-items-center justify-content-center"
                        >
                            <Badge bg="info" className="px-3 py-2">
                                To
                            </Badge>
                        </Col>

                        <Col md={5}>
                            <DatePicker
                                id="document-to-date-picker"
                                name="documentTo"
                                className="form-control"
                                value={
                                    searchValue.documentTo
                                        ? moment(
                                              searchValue.documentTo,
                                              "YYYY-MM-DD"
                                          )
                                        : null
                                }
                                placeholder="To"
                                onChange={(e) =>
                                    updateDateFilter("documentTo", e)
                                }
                            />
                        </Col>
                    </Row>
                </Col>

                <Col md={3}>
                    <div className="mb-1 text-muted fw-semibold">
                        Payments until
                    </div>
                    <DatePicker
                        id="payment-date-picker"
                        name="paymentTo"
                        className="form-control"
                        value={
                            searchValue.paymentTo
                                ? moment(searchValue.paymentTo, "YYYY-MM-DD")
                                : null
                        }
                        placeholder="Payments until"
                        onChange={(e) => updateDateFilter("paymentTo", e)}
                    />
                </Col>

                {/* Company Select */}
                <Col md={4}>
                    <div className="mb-1 text-muted fw-semibold">Company</div>
                    <AsyncPaginate
                        className="render-above"
                        isClearable
                        loadOptions={handleLoadMore}
                        hasMore={hasMore}
                        placeholder="Search company"
                        additional={{ page: 1 }}
                        onChange={(value) => {
                            setSearchValue({
                                ...searchValue,
                                company: value ? value.value : "",
                            });
                            setCompanyName(value ? value.label : "");
                        }}
                    />
                </Col>
                {/* Salesperson Select */}
                <Col md={4}>
                    <div className="mb-1 text-muted fw-semibold">Salesperson</div>
                        <Select
                        isClearable
                        className="react-select-container render-above"
                        classNamePrefix="react-select"
                        options={addDefaultOption(salesPersons)}
                        name="salesperson"
                        placeholder="Search salesperson"
                        onChange={(event) => {
                            setSearchValue({
                                ...searchValue,
                                salesperson: event?.value,
                            });
                        }}
                    />
                </Col>

                {/* Search Button */}
                <Col md="auto">
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-search">Search filter</Tooltip>
                        }
                    >
                        <Button
                            variant="info"
                            onClick={(e) => {
                                e.preventDefault();
                                search({ page: 1 });
                            }}
                            title="Search filter"
                            className="me-2"
                        >
                            <Filter size={15} />
                        </Button>
                    </OverlayTrigger>
                </Col>

                {/* Export Button */}
                <Col md="auto">
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-export">
                                Export Unpaid Invoices
                            </Tooltip>
                        }
                    >
                        <Button
                            variant="info"
                            title="Export Unpaid Invoices"
                            onClick={() => generateReport()}
                        >
                            <FontAwesomeIcon icon={faFileExport} />
                        </Button>
                    </OverlayTrigger>
                </Col>

                <Col md="auto">
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-export">
                                Export Unpaid Invoices + SAP
                            </Tooltip>
                        }
                    >
                        <Button
                            variant="info"
                            title="Export Unpaid Invoices + SAP"
                            onClick={() => excelExport()}
                        >
                            <FontAwesomeIcon icon={faFileExcel} />
                        </Button>
                    </OverlayTrigger>
                </Col>
            </Row>
        </div>
    );
};
